import Vue from 'vue';

let interval: any = null;

const timeState: {
	_now: Date;
} = Vue.observable({ _now: new Date() });

class TimeService {
    updateTimer() {
        timeState._now = new Date();
    }

    get Now(): Date {
        return timeState._now;
    }

    get Unix(): number {
        return Math.floor(timeState._now.getTime() / 1000);
    }

    constructor() {
        if (interval) clearInterval(interval);

        interval = setInterval(() => this.updateTimer(), 1000);
    }
}

export default new TimeService();
